import { render, staticRenderFns } from "./mitra-period-month-select.vue?vue&type=template&id=8009d1d2&"
import script from "./mitra-period-month-select.vue?vue&type=script&lang=js&"
export * from "./mitra-period-month-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports